export enum ImageManipulationFormat {
  Jpeg = "jpeg"
}

export interface ImageManipulationOptions {
  width?: number;
  format?: ImageManipulationFormat;
}
